import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrending4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-4, chart"} maskId="square-filled-radius-0-stroke-1-IconTrending4"><path fillRule="evenodd" clipRule="evenodd" d="M3 4V19H22V20H2V4H3ZM15 6H20V11H19V7.70711L13 13.7071L11 11.7071L5.5 17.2071L4.79289 16.5L11 10.2929L13 12.2929L18.2929 7H15V6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrending4;
